import React from 'react'

import { MongoCollection } from '../../../types/mongoConnector'

type Props = {
  collection: MongoCollection
  action?: React.ReactNode
}

export default function SyncedCollection({ collection, action }: Props) {
  return (
    <div
      className="flex items-center justify-between py-2.5 pl-4 pr-5"
      data-testid="collectionRow"
    >
      <div className="flex flex-col">
        <span>{collection.name}</span>
        <span className="text-foreground-subtle text-sm">
          ID: {collection.idMappingFields.join(', ')}
        </span>
        {collection.dittoTypes?.settableCounters &&
          collection.dittoTypes.settableCounters.length > 0 && (
            <span className="text-foreground-subtle text-sm">
              Counters: {collection.dittoTypes.settableCounters.join(', ')}
            </span>
          )}
      </div>

      {action}
    </div>
  )
}
